import React, { useState, useEffect } from 'react';
import FontFaceObserver from 'fontfaceobserver';

import AppRouter from './AppRouter';
import PrimaryColorLoader from './components/PrimaryColorsLoader';
import { ModalProvider } from './context/ModalContext';
import 'react-notifications/lib/notifications.css';
import LoadingSpinner from './components/common/LoadingSpinner';
import { ENVIRONMENT } from './ConfigVars';

const App = () => {
  const [fontsLoaded, setFontsLoaded] = useState(false);

  useEffect(() => {
    const montserrat = new FontFaceObserver('Montserrat', { weight: 400 });
    const nunito = new FontFaceObserver('Nunito', { weight: 400 });

    Promise.all([montserrat.load(), nunito.load()])
      .then(() => {
        setFontsLoaded(true);
      })
      .catch(() => {
        setFontsLoaded(true); // Render app even if fonts fail to load
      });
  }, []);

  return (
    <div className="mx-auto min-h-screen min-w-72 max-w-2xl bg-pj-gray-400 px-3 font-montserrat xxxs:px-4 xxs:px-8">
      {!fontsLoaded ? (
        <div className="mt-8">
          <LoadingSpinner message="Loading fonts" dark />
        </div>
      ) : (
        <>
          {(ENVIRONMENT === 'DEVELOPMENT' || ENVIRONMENT === 'STAGING') && (
          <div className="absolute right-2 top-2 z-50 bg-red-500/15 p-4 text-2xl font-semibold text-red-700 opacity-75">
            {ENVIRONMENT}
          </div>
          )}
          <PrimaryColorLoader />
          <ModalProvider>
            <AppRouter />
          </ModalProvider>
        </>
      )}
    </div>
  );
};

export default App;
